module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/osbornebulls.d50530e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/osbornebulls.jpg
// module id = M9Mr
// module chunks = 0